import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import url from './assets/icon.png';
import * as styles from './index.css';
import { trackClickOnBanner } from './tracking';

export function SuburbanBanner() {
  return (
    <section className={styles['container']}>
      <div className={styles['content']}>
        <span className={styles['title']}>Хотите продать недвижимость?</span>
        <span className={styles['subtitle']}>Разместите объявление на Циан</span>
        <LinkButton
          size="XS"
          theme="fill_primary"
          target="_blank"
          rel="noreferrer"
          href="https://www.cian.ru/razmestit-obyavlenie/"
          onClick={trackClickOnBanner}
        >
          Разместить
        </LinkButton>
      </div>
      <img src={url} />
    </section>
  );
}
